/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiDropContextProfileContext } from '../models/ApiDropContextProfileContext';
import { ApiDropMentionedUser } from '../models/ApiDropMentionedUser';
import { ApiDropMetadata } from '../models/ApiDropMetadata';
import { ApiDropPart } from '../models/ApiDropPart';
import { ApiDropRater } from '../models/ApiDropRater';
import { ApiDropReaction } from '../models/ApiDropReaction';
import { ApiDropReferencedNFT } from '../models/ApiDropReferencedNFT';
import { ApiDropSubscriptionTargetAction } from '../models/ApiDropSubscriptionTargetAction';
import { ApiDropType } from '../models/ApiDropType';
import { ApiDropWinningContext } from '../models/ApiDropWinningContext';
import { ApiProfileMin } from '../models/ApiProfileMin';
import { ApiReplyToDropResponse } from '../models/ApiReplyToDropResponse';
import { HttpFile } from '../http/http';

export class ApiDropWithoutWave {
    'id': string;
    /**
    * Sequence number of the drop in Seize
    */
    'serial_no': number;
    'drop_type': ApiDropType;
    'rank': number | null;
    'winning_context'?: ApiDropWinningContext;
    'reply_to'?: ApiReplyToDropResponse;
    'author': ApiProfileMin;
    /**
    * Time when the drop was created in milliseconds since 1-1-1970 00:00:00.0 UTC
    */
    'created_at': number;
    /**
    * Time when the drop was updated in milliseconds since 1-1-1970 00:00:00.0 UTC
    */
    'updated_at': number | null;
    'title': string | null;
    'parts': Array<ApiDropPart>;
    /**
    * Number of drops in the storm
    */
    'parts_count': number;
    'referenced_nfts': Array<ApiDropReferencedNFT>;
    'mentioned_users': Array<ApiDropMentionedUser>;
    'metadata': Array<ApiDropMetadata>;
    'rating': number;
    'realtime_rating': number;
    'rating_prediction': number;
    'top_raters': Array<ApiDropRater>;
    'raters_count': number;
    'context_profile_context': ApiDropContextProfileContext | null;
    'subscribed_actions': Array<ApiDropSubscriptionTargetAction>;
    'is_signed': boolean;
    'reactions': Array<ApiDropReaction>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "serial_no",
            "baseName": "serial_no",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "drop_type",
            "baseName": "drop_type",
            "type": "ApiDropType",
            "format": ""
        },
        {
            "name": "rank",
            "baseName": "rank",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "winning_context",
            "baseName": "winning_context",
            "type": "ApiDropWinningContext",
            "format": ""
        },
        {
            "name": "reply_to",
            "baseName": "reply_to",
            "type": "ApiReplyToDropResponse",
            "format": ""
        },
        {
            "name": "author",
            "baseName": "author",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "updated_at",
            "baseName": "updated_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "parts",
            "baseName": "parts",
            "type": "Array<ApiDropPart>",
            "format": ""
        },
        {
            "name": "parts_count",
            "baseName": "parts_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "referenced_nfts",
            "baseName": "referenced_nfts",
            "type": "Array<ApiDropReferencedNFT>",
            "format": ""
        },
        {
            "name": "mentioned_users",
            "baseName": "mentioned_users",
            "type": "Array<ApiDropMentionedUser>",
            "format": ""
        },
        {
            "name": "metadata",
            "baseName": "metadata",
            "type": "Array<ApiDropMetadata>",
            "format": ""
        },
        {
            "name": "rating",
            "baseName": "rating",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "realtime_rating",
            "baseName": "realtime_rating",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "rating_prediction",
            "baseName": "rating_prediction",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "top_raters",
            "baseName": "top_raters",
            "type": "Array<ApiDropRater>",
            "format": ""
        },
        {
            "name": "raters_count",
            "baseName": "raters_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "context_profile_context",
            "baseName": "context_profile_context",
            "type": "ApiDropContextProfileContext",
            "format": ""
        },
        {
            "name": "subscribed_actions",
            "baseName": "subscribed_actions",
            "type": "Array<ApiDropSubscriptionTargetAction>",
            "format": ""
        },
        {
            "name": "is_signed",
            "baseName": "is_signed",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "reactions",
            "baseName": "reactions",
            "type": "Array<ApiDropReaction>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiDropWithoutWave.attributeTypeMap;
    }

    public constructor() {
    }
}


